/* albm-tabs.js — <albm-tabs> · OWNER: T0
   role=tablist + phím mũi tên. Lọc item bằng data-tab (ranking, news, ranking period).
   Markup:
     <albm-tabs>
       <div class="albm-tabs" role="tablist">
         <button role="tab" data-albm-tab="all" aria-selected="true" …>すべて</button>
       </div>
       <div data-albm-panel>
         <div data-tab="all shampoo">…</div>
       </div>
     </albm-tabs>
*/
class AlbmTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-albm-tab]'));
    if (!this.tabs.length) return;
    this.items = Array.from(this.querySelectorAll('[data-tab]'));

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
    });

    const initial = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    this.select(initial < 0 ? 0 : initial, false);
  }

  onKeydown(event, index) {
    const last = this.tabs.length - 1;
    let next = null;
    if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
    else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = last;
    if (next === null) return;
    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }

  select(index, notify = true) {
    const value = this.tabs[index]?.dataset.albmTab;
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
      tab.classList.toggle('is-active', active);
    });
    this.items.forEach((item) => {
      const list = (item.dataset.tab || '').split(/\s+/).filter(Boolean);
      const show = !value || value === 'all' || list.includes(value) || list.includes('all');
      item.hidden = !show;
    });
    if (notify) {
      this.dispatchEvent(new CustomEvent('albm:tabchange', { bubbles: true, detail: { value } }));
    }
  }
}

if (!customElements.get('albm-tabs')) {
  customElements.define('albm-tabs', AlbmTabs);
}
